import { AbstractSlingoAnimationSpineProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractSlingoAnimationProperties";
/**
* SlingoAnimationLandscapeProperties.ts
*/
export class SlingoAnimationLandscapeProperties extends AbstractSlingoAnimationSpineProperties {
    constructor() {
        super();
        this.position.set(973, 452);
        this.scale.set(0.73);
        this.animationNameArray = ["", "slingo-win-single", "slingo-win-double", "slingo-win-triple", "slingo-win-quadruple"];
    }
}
//# sourceMappingURL=SlingoAnimationLandscapeProperties.js.map